module.exports = __webpack_public_path__ + "static/media/step3.63b9e5af.png";